/*eslint-disable*/
export default {
  init() {
    const swiperPartners = new Swiper(".partners__container-list", {
      loop: true,
      slidesPerView: 1,
      direction: "horizontal",
      spaceBetween: 30,
      speed: 500,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
        },
        768: {
          slidesPerView: 3,
        },
        475: {
          slidesPerView: 2,
        },
      }
    });

    const swiperSponsors = new Swiper(".partners__container-sponsors", {
      loop: true,
      slidesPerView: 1,
      direction: "horizontal",
      spaceBetween: 30,
      speed: 500,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
        },
        768: {
          slidesPerView: 3,
        },
        475: {
          slidesPerView: 2,
        },
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templatePartners.js